import Vue from 'vue';
import Router from 'vue-router';

import Admin from '@/Admin';
import Partners from '@/components/Partners';
import Partner from '@/components/Partner';
import Opportunities from '@/components/Opportunities';
import Opportunity from '@/components/Opportunity';
import Locations from '@/components/Locations';
import Location from '@/components/Location';
import Languages from '@/components/Languages';
import Language from '@/components/Language';
import ManualPortals from '@/components/ManualPortals';
import ManualPortal from '@/components/ManualPortal';
import AutomaticPortals from '@/components/AutomaticPortals';
import History from '@/components/History';
import Reports from '@/components/Reports';
import ReportsContacts from '@/components/ReportsContacts';
import ReportsContactsAnalysis from '@/components/ReportsContactsAnalysis';
import ReportsRealestate from '@/components/ReportsRealestate';
import ReportsRealestateAnalysis from '@/components/ReportsRealestateAnalysis';
import ReportsOpportunityQuestionnaire from '@/components/ReportsOpportunityQuestionnaire';
import ReportsOpportunityBuyer from '@/components/ReportsOpportunityBuyer';
import Contacts from '@/components/Contacts'
import Contact from '@/components/Contact';
import Codebooks from '@/components/Codebooks';
import CodebooksHeating from '@/components/CodebooksHeating';
import CodebooksAdditionalInfo from '@/components/CodebooksAdditionalInfo';
import ReportsPartners from '@/components/ReportsPartners';
import ReportsPartnersRealestate from '@/components/ReportsPartnersRealestate';

Vue.use(Router);

export default new Router({
	routes: [
		{
			path: '/', name: '', component: Admin,
			children: [
				{path: '/partners', name: 'partners', component: Partners, meta: {}},
				{path: '/partners/:id', name: 'partner', component: Partner, meta: {}},
				{path: '/contacts', name: 'contacts', component: Contacts, meta: {}},
				{path: '/contacts/:id', name: 'contact', component: Contact, meta: {}},
				{path: '/opportunities', name: 'opportunities', component: Opportunities, meta: {}},
				{path: '/opportunities/:id', name: 'opportunity', component: Opportunity, meta: {}},
				{path: '/locations', name: 'locations', component: Locations, meta: {}},
				{path: '/locations/:id', name: 'location', component: Location, meta: {}},
				{path: '/languages', name: 'languages', component: Languages, meta: {}},
				{path: '/languages/:id', name: 'language', component: Language, meta: {}},
				{path: '/manual-portals', name: 'manual-portals', component: ManualPortals, meta: {}},
				{path: '/manual-portals/:id', name: 'manual-portal', component: ManualPortal, meta: {}},
				{path: '/automatic-portals', name: 'automatic-portals', component: AutomaticPortals, meta: {}},
				{path: '/history', name: 'history', component: History, meta: {}},
				{path: '/reports', name: 'reports', component: Reports, meta: {}},
				{path: '/reports/contacts', name: 'reportsContacts', component: ReportsContacts, meta: {}},
				{path: '/reports/realestate', name: 'reportsRealestate', component: ReportsRealestate, meta: {}},
				{path: '/reports/opportunity-questionnaire/:contact_id/:questionnaire_id', name: 'reportsOpportunityQuestionnaire', component: ReportsOpportunityQuestionnaire, meta: {}},
				{path: '/reports/opportunity-questionnaire', name: 'reportsOpportunityQuestionnaire', component: ReportsOpportunityQuestionnaire, meta: {}},
				{path: '/reports/opportunity-buyer', name: 'reportsOpportunityBuyer', component: ReportsOpportunityBuyer, meta: {}},
				{path: '/codebooks', name: 'codebooks', component: Codebooks, meta: {}},
				{path: '/codebooks/heating', name: 'codebooksHeating', component: CodebooksHeating, meta: {}},
				{path: '/codebooks/additional-info', name: 'codebooksAdditionalInfo', component: CodebooksAdditionalInfo, meta: {}},
				{path: '/reports/realestate-analysis', name: 'reportsRealestateAnalysis', component: ReportsRealestateAnalysis, meta: {}},
				{path: '/reports/contacts-analysis', name: 'reportsContactsAnalysis', component: ReportsContactsAnalysis, meta: {}},
				{path: '/reports/partners', name: 'reportsPartners', component: ReportsPartners, meta: {}},
				{path: '/reports/partners-realestate', name: 'reportsPartnersRealestate', component: ReportsPartnersRealestate, meta: {}},
			]
		}
	]
});
